import c from "./constants";

const env = (() => {
    const getApiRoot = () => {
        var apiRoot;
        var location = window.location.hostname.toLowerCase();

        if (_isProd(location))
            apiRoot = "https://bigfoot.jugglestreet.com";
        else if (_isStaging(location))
            apiRoot = "https://sbigfoot.jugglestreet.com";
        else if (_isLocal(location))
            apiRoot = "https://dbigfoot.jugglestreet.com";
        else if (_isDev(location))
            apiRoot = "http://localhost:7171";

        return apiRoot;
    }

    const getApiUrl = (path) => {
        const apiRoot = getApiRoot(path);

        return `${apiRoot}/api/${path}`;
    }

    const getLoginAsBaseUrl = (targetDevice, country) => {
        let rootUrl;
        var location = window.location.hostname.toLowerCase();

        if(targetDevice == c.deviceType.DESKTOP) {

            if(_isProd(location)) rootUrl = country === "au" ? "https://web.jugglestreet.com.au/" : "https://web.jugglestreet.co.nz/";
            else if(_isStaging(location)) rootUrl = "https://sw.jugglestreet.com/";
            else if(_isLocal(location)) rootUrl = "//localhost:3000/";
            else if(_isDev(location)) rootUrl = "//frontendserver:3000/";

        } else {
            if(_isProd(location)) rootUrl = country === "au" ? "https://m.jugglestreet.com.au/" : "https://m.jugglestreet.co.nz/";
            else if(_isStaging(location)) rootUrl = "https://sm.jugglestreet.com/";
            else if(_isLocal(location)) rootUrl = "//localhost:8080/";
            else if(_isDev(location)) rootUrl = "//frontendserver:8080/";
        }

        return rootUrl;
    }

    const getStorageUrl = (path) => {
        var storageUrl;
        var location = window.location.hostname.toLowerCase();

        if (_isProd(location))
            storageUrl = "https://jsprodaue.blob.core.windows.net/";
        else if (_isStaging(location))
            storageUrl = "https://jsstagingaue.blob.core.windows.net/";
        else if (_isLocal(location))
            storageUrl = "https://jsdevaue.blob.core.windows.net/";
        else if (_isDev(location))
            storageUrl = "https://jsdevlocalaue.blob.core.windows.net/";

        return storageUrl;
    }

    const isAdmin = () => {
        var location = window.location.hostname.toLowerCase();
        return location.startsWith("admin") || location.startsWith("sadmin");
    }

    const isAnalytics = () => {
        var location = window.location.hostname.toLowerCase();
        return location.startsWith("analytics")|| location.startsWith("sanalytics");
    }

    const defaultState = () => {
      let defaultState;
        if (env.isAdmin()) {
        defaultState = "users";
      } else if (env.isAnalytics()) {
        defaultState = "analyticsUsers";
      } else {
        throw new Error("Unsupported subdomain");
      }

      return defaultState;
    }

    const pageTitle = () => {
        let pageTitle;
      if (env.isAdmin()) {
        pageTitle = "Juggle Street Admin Portal";
      } else if (env.isAnalytics()) {
        pageTitle = "Juggle Street Analytics Portal";
      } else {
        throw new Error("Unsupported subdomain");
      }

      return pageTitle;
    }

    const _isLocal = (location) => location.startsWith("localhost");

    const _isDev = (location) => location.indexOf("frontendserver") != -1 || location.indexOf("local") != -1;

    const _isProd =  (location) => location.startsWith("admin.jugglestreet.com") || location.startsWith("analytics.jugglestreet.com");

    const _isStaging =  (location) => location.startsWith("sadmin.jugglestreet.com") || location.startsWith("sanalytics.jugglestreet.com");

    return { getApiRoot, getApiUrl, getLoginAsBaseUrl, getStorageUrl, isAdmin, isAnalytics, defaultState, pageTitle  };
})()

export default env;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/utils/env.js
 **/